/**
 * App bootstrap: Router → Vuex → Vuetify → ApexCharts, then explicit global base SFCs.
 * HTTP goes through src/api/Api.js (Axios).
 */
import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import store from './store';
import router from './router';
import VueApexCharts from 'vue3-apexcharts';
import { installDarkModeHelper } from '@/helpers/vuetifyTheme';

import BaseCurrencyPicker from '@/components/base/BaseCurrencyPicker.vue';
import BaseMainNavBtn from '@/components/base/BaseMainNavBtn.vue';
import BaseMainNavMenu from '@/components/base/BaseMainNavMenu.vue';
import BaseViewBtn from '@/components/base/BaseViewBtn.vue';
import BaseDataTable from '@/components/base/datatable/BaseDataTable.vue';
import BaseDataTableRemote from '@/components/base/datatable/BaseDataTableRemote.vue';
import BaseDataTableBtn from '@/components/base/datatable/BaseDataTableBtn.vue';
import BaseDataTableEditableField from '@/components/base/datatable/BaseDataTableEditableField.vue';
import BaseDialogPrompt from '@/components/base/dialog/BaseDialogPrompt.vue';
import BaseDialogConfirmation from '@/components/base/dialog/BaseDialogConfirmation.vue';
import BaseDialogDeleteConfirmation from '@/components/base/dialog/BaseDialogDeleteConfirmation.vue';
import BaseSidebar from '@/components/base/sidebar/BaseSidebar.vue';
import BaseSidebarEditor from '@/components/base/sidebar/BaseSidebarEditor.vue';
import BaseSidebarBtn from '@/components/base/sidebar/BaseSidebarBtn.vue';
import BaseSidebarViewerBtn from '@/components/base/sidebar/BaseSidebarViewerBtn.vue';
import BaseViewContainer from '@/components/base/view/BaseViewContainer.vue';
import BaseViewHeader from '@/components/base/view/BaseViewHeader.vue';
import BaseViewHeaderBtn from '@/components/base/view/BaseViewHeaderBtn.vue';
import BaseViewHeaderPrimaryBtn from '@/components/base/view/BaseViewHeaderPrimaryBtn.vue';
import BaseViewHeaderSearch from '@/components/base/view/BaseViewHeaderSearch.vue';
import BaseAuthViewContainer from '@/components/base/view/BaseAuthViewContainer.vue';
import BaseErrorAlerts from '@/components/base/view/BaseErrorAlerts.vue';

import '@fontsource/roboto/100.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';
import '@/assets/style.css';
import '@/assets/vuetify2-compat.css';

const app = createApp(App);

app.use(router);
app.use(store);
app.use(vuetify);
app.use(VueApexCharts);

installDarkModeHelper(app);

app.component('apexchart', VueApexCharts);

app.component('BaseCurrencyPicker', BaseCurrencyPicker);
app.component('BaseMainNavBtn', BaseMainNavBtn);
app.component('BaseMainNavMenu', BaseMainNavMenu);
app.component('BaseViewBtn', BaseViewBtn);
app.component('BaseDataTable', BaseDataTable);
app.component('BaseDataTableRemote', BaseDataTableRemote);
app.component('BaseDataTableBtn', BaseDataTableBtn);
app.component('BaseDataTableEditableField', BaseDataTableEditableField);
app.component('BaseDialogPrompt', BaseDialogPrompt);
app.component('BaseDialogConfirmation', BaseDialogConfirmation);
app.component('BaseDialogDeleteConfirmation', BaseDialogDeleteConfirmation);
app.component('BaseSidebar', BaseSidebar);
app.component('BaseSidebarEditor', BaseSidebarEditor);
app.component('BaseSidebarBtn', BaseSidebarBtn);
app.component('BaseSidebarViewerBtn', BaseSidebarViewerBtn);
app.component('BaseViewContainer', BaseViewContainer);
app.component('BaseViewHeader', BaseViewHeader);
app.component('BaseViewHeaderBtn', BaseViewHeaderBtn);
app.component('BaseViewHeaderPrimaryBtn', BaseViewHeaderPrimaryBtn);
app.component('BaseViewHeaderSearch', BaseViewHeaderSearch);
app.component('BaseAuthViewContainer', BaseAuthViewContainer);
app.component('BaseErrorAlerts', BaseErrorAlerts);

if (process.env.NODE_ENV === 'development') {
  app.config.performance = true;
}

app.mount('#app');
